import { Row } from 'components/base';
import type React from 'react';
import type { PropsWithChildren } from 'react';

export const Container: React.FC<PropsWithChildren> = ({ children }) => (
  <Row fullHeight={true}>{children}</Row>
);
